"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDryer = function IconDryer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.811 7.811A2.77 2.77 0 0 1 11.77 7H18v4.97H9v-2.2c0-.735.292-1.44.811-1.959M39 11.97v-2.2A2.77 2.77 0 0 0 36.23 7H19v4.97zM9 38.23V13.97h30v24.26A2.77 2.77 0 0 1 36.23 41H11.77A2.77 2.77 0 0 1 9 38.23M11.77 5A4.77 4.77 0 0 0 7 9.77v28.46A4.77 4.77 0 0 0 11.77 43h24.46A4.77 4.77 0 0 0 41 38.23V9.77A4.77 4.77 0 0 0 36.23 5zm3.68 21.5a8.55 8.55 0 1 1 17.1 0 8.55 8.55 0 0 1-17.1 0M24 16.05c-5.771 0-10.45 4.679-10.45 10.45S18.229 36.95 24 36.95s10.45-4.679 10.45-10.45S29.771 16.05 24 16.05m0-6.55a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M37 10h-5V9h5zm-6 0h-2V9h2zm-9.888 11.358L19.6 21l-.186.605-.08.247a7.97 7.97 0 0 0 .08 4.813 6.9 6.9 0 0 1 0 4.366l-.216.598 1.485.357.215-.605.08-.247a7.97 7.97 0 0 0-.08-4.813 6.9 6.9 0 0 1 0-4.365zM23.458 21l1.484.358-.244.598a6.9 6.9 0 0 0 0 4.365 7.92 7.92 0 0 1 .087 4.813l-.087.247-.215.605L23 31.63l.222-.598a6.9 6.9 0 0 0 0-4.366 7.92 7.92 0 0 1-.086-4.812l.129-.248zm3.858 0 1.485.358-.215.598a6.9 6.9 0 0 0 0 4.365 7.98 7.98 0 0 1 0 5.074l-.223.605-1.477-.358.215-.598a6.9 6.9 0 0 0 0-4.365 7.98 7.98 0 0 1 0-5.074z",
    clipRule: "evenodd"
  })));
};

export { IconDryer, IconDryer as default };
